import { Reveal } from "../Reveal";
import { IMAGES } from "../../lib/siteData";

export const SectionHeading = ({ eyebrow, title, subtitle, light = false }) => (
  <div className="max-w-3xl">
    <div className={`mb-4 font-body text-xs font-semibold uppercase tracking-[0.2em] ${light ? "text-lime-bright" : "text-forest-600"}`}>
      {eyebrow}
    </div>
    <h2 className={`font-heading text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl ${light ? "text-white" : "text-forest"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 font-body text-base leading-relaxed ${light ? "text-white/70" : "text-muted-foreground"}`}>
        {subtitle}
      </p>
    )}
  </div>
);

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <Reveal>
          <SectionHeading eyebrow="Who We Are" title="One coordinated framework for greener, smarter assets" />
          <p className="mt-6 font-body text-base leading-relaxed text-muted-foreground">
            Frontiers Infra Sustainability Consortium is a multi-partner platform that helps developers,
            industrial parks, campuses, townships, and infrastructure projects deliver greener, smarter,
            and more resilient assets through one coordinated framework.
          </p>
          <p className="mt-4 font-body text-base leading-relaxed text-muted-foreground">
            Rather than engaging multiple disconnected consultants and technical vendors, clients work
            through a single coordinated framework that improves execution clarity, sustainability
            alignment, and lifecycle value.
          </p>
          <div className="mt-8 border-l-2 border-lime-bright bg-forest-50 p-5">
            <p className="font-body text-sm font-medium leading-relaxed text-forest">
              Integrated design, sustainability, renewable energy, intelligent lighting, and digital
              performance solutions that help clients create greener, smarter, more resilient, and
              investment-ready developments.
            </p>
          </div>
        </Reveal>

        <Reveal delay={150} className="relative">
          <img
            src={IMAGES.about}
            alt="Sustainable architecture detail"
            className="h-[420px] w-full rounded-2xl border border-border object-cover grayscale lg:h-[500px]"
            loading="lazy"
          />
        </Reveal>
      </div>
    </section>
  );
};
